module.exports = __webpack_public_path__ + "static/hotel-booking-web-plp-ab7e2bac739d344da933aae1de372e8a.png";